/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventScreenNewMobile_query = {
    readonly " $fragmentRefs": FragmentRefs<"SponsorsSection_query" | "EventScreenAttendCard_query" | "EventScreenJoin_query">;
    readonly " $refType": "EventScreenNewMobile_query";
};
export type EventScreenNewMobile_query$data = EventScreenNewMobile_query;
export type EventScreenNewMobile_query$key = {
    readonly " $data"?: EventScreenNewMobile_query$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventScreenNewMobile_query">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenNewMobile_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SponsorsSection_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenAttendCard_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenJoin_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = '58ea352ddbf634ca04bd23db855ccc15';
export default node;
